import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { FormControl } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonBookingService } from '../common-booking.service';
import { BookingActionsHeaderService } from './booking-actions-header.service';
import { CommonBillingService } from 'src/app/billing/shared/common-billing.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { DownloadAsCsvService } from 'src/app/shared/services/download-as-csv.service';
import { CreateBookingService } from '../../create-booking/create-booking.service';

@Component({
  selector: 'app-booking-actions-header',
  templateUrl: './booking-actions-header.component.html',
  styleUrls: ['./booking-actions-header.component.scss']
})
export class BookingActionsHeaderComponent implements OnInit {

  @Input() selectedBookings: any;
  @Input() selectedBookingDetailed: any;
  @Input() vendors: any;
  @Input() cancelCutOffDetails: any;
  @Input() totalNoOfTrips: any;
  @Input() tripsWithNoVendors: any;
  @Input() tripsWithNoCabs: any;
  @Input() cancelledTrips: any;
  @Input() marshallNotAssigned: any;
  @Input() sendComm: boolean;
  @Input() assignVendor: boolean;
  @Input() config: any;
  @Input() bookingBulkActionsConfig: any;
  @Input() startDate: any;
  @Input() endDate: any;
  @Input() filterFormDetails: any;
  @Input() now: number;
  @Input() state;
  @Input() vendorSelectConfigObj: any;
  @Input() searchInput: string;
  @Input() downloadCallback;
  @Input() showCheckboxHyphen: boolean;
  @Input() allBookingsSelected: any;
  @Input() miscelleneousConfig: any;
  @Input() multiDayBookings: any;
  @Input() tripCompleted: any;
  @Output() checkboxSelected = new EventEmitter();
  @Output() selectVendorAssigned = new EventEmitter();
  @Output() selectVendorUnAssigned = new EventEmitter();

  @Output() searchInputChangeCallBack = new EventEmitter();
  @Output() handleBookingsUpdateCallback = new EventEmitter();
  @Output() toggleLoadingCallBack =  new EventEmitter();
  @Output() getDetailsCallback = new EventEmitter();
  @Output() showCancelBookingErrorCallback = new EventEmitter();
  @Output() showCancelBookingSuccessCallback = new EventEmitter();
  @Output() selectedBookingsVendorValuesReset = new EventEmitter();
  @Output() toggleAutoReload = new EventEmitter();
  @Output() showSuccessToast = new EventEmitter();
  @Output() mergeBookingCallback = new EventEmitter();

  public selectedVendor: any;
  public bulkActionsConfig: any;
  public vendorSelectConfig: any;
  public vendorFormControl = new FormControl();
  public showCancelConfirmDialog = false;
  public selectedBookingsText: string;
  canCutoffPassedBooking: string;
  public summaryConfig: any;
  public bulkbookingActionsConfigObj = {};
  public summaryConfigObj = {};
  // public isSendCommVisible: boolean;
  public isCabTrackVisible: boolean;
  public submitButtonConfig: any;
  public mergeError: string;
  public mergeBookingConfig: any;
  public isMergeVisible: boolean;
  public downloadReportFailed: string;
  bookingWithinCancelCutOff: string[] = [];
  bookingWithCutOffPassed: string[] = [];
  cancelPopUpConfig: any;
  rejectPopupConfig: any;
  denyPopupConfig: any;
  @ViewChild('fileUpload') inputVar: ElementRef;
  showFileUploadModal: boolean;
  fileToUpload: any;
  uploadFileError: string;
  isLoading: boolean;
  successMessage: string;
  showToast: boolean;
  showModal = false;
  mergeVendorError = false;
  configComplete: any;


  constructor(private commonService: CommonService, private authService: AuthService,
              private commonBookingService: CommonBookingService, private bookingActionsHeaderService: BookingActionsHeaderService,
              private commonBillingService: CommonBillingService, private utilService: UtilService,
              private downloadAsCsvService: DownloadAsCsvService,
              private createBookingService: CreateBookingService) { }

  ngOnInit() {
    this.setConfigs();
    this.commonService.fetchConfig().subscribe((response) => {
      this.configComplete = response;
      this.mergeBookingConfig = this.commonService.getConfigForElementKey(response, 'Merge Bookings Pop-Up');
    });
  }

  closeAssignVendor(){
    this.showModal = false;
  }


  setConfigs() {
    if (this.config) {
      this.bulkActionsConfig = this.commonService.getConfigForElementKey(this.config, 'Bulk Actions Ellipsis');
      this.summaryConfig = this.commonService.getConfigForElementKey(this.config, 'Summary');
      this.submitButtonConfig = this.commonService.getConfigForElementKey(this.config, 'Submit Button');
      this.setBookingheaderConfig();
      this.setReasonConfig();
    }
  }

  setReasonConfig() {
    this.commonService.fetchConfig().subscribe((response: any) => {
      const reasonConfigSection = this.commonService.getConfigForElementKey(response, 'Booking Action Popup');
      this.cancelPopUpConfig = this.commonService.getConfigForElementKey(reasonConfigSection, 'Cancel Booking');
      this.rejectPopupConfig = this.commonService.getConfigForElementKey(reasonConfigSection, 'Reject Booking');
      this.denyPopupConfig = this.commonService.getConfigForElementKey(reasonConfigSection, 'Deny Booking');
    });
  }

  setBookingheaderConfig() {
    for (const configData of this.bulkActionsConfig.elementConfigList) {
      this.bulkbookingActionsConfigObj[configData.elementKey] = configData.config;
    }
    for (const configData of this.summaryConfig.elementConfigList) {
      this.summaryConfigObj[configData.elementKey] = configData.config;
    }
  }

  handleSearch(event) {
    // Emitting the event only if user presses Enter or if search box is empty
    if ((this.searchInput && event.keyCode === 13 || this.searchInput == "") && this.searchInputChangeCallBack ) {
      const searchData = this.searchInput.trim();
      this.searchInputChangeCallBack.emit({value: searchData});
    }
  }

  onVendorValueSelected(vendorguId: string) {
    if (this.selectedBookingsVendorValuesReset) {
      this.selectedBookingsVendorValuesReset.emit(vendorguId);
    }
  }

  handleStatusUpdate(data: any) {
    if (this.handleBookingsUpdateCallback) {
      this.handleBookingsUpdateCallback.emit(data);
    }
  }

  clearUpdate(){
    this.vendorFormControl.reset();
  }

  handleSubmitVendorUpdate() {
    if (this.handleBookingsUpdateCallback) {
      this.handleBookingsUpdateCallback.emit({action: 'vendor-cab-update'});
      this.closeAssignVendor();
      this.vendorFormControl.reset();
    }
    this.showModal = false;

  }

  handleDismissUploadFileModal() {
    this.fileToUpload = null;
    this.showFileUploadModal = false;
    this.uploadFileError = '';
  }

  handleUploadReport(files: any) {
    this.fileToUpload = files.item(0);
    if (files.item(0)) {
      this.showFileUploadModal = true;
    }
    this.inputVar.nativeElement.value = '';
  }

  toggleToastBillRepost() {
    this.showToast = false;
  }

  submitUploadReport() {
    this.isLoading = true;
    const request = {
      uploadFile: this.fileToUpload
    };
    const queryParams = {
      buid: this.authService.user.buId,
      client: this.authService.client.client,
    };
    this.createBookingService.uploadRateCard(request, queryParams).subscribe((response) => {
      this.isLoading = false;
      this.fileToUpload = null;
      this.showFileUploadModal = false;
      this.uploadFileError = '';
      this.successMessage = "Document is successfully uploaded.";
      this.showToast = true;
    }, (data) => {
      this.isLoading = false;
      this.uploadFileError = data.error.message || 'Upload failed!';
    });
  }

  cancelBooking(reason: string) {
    const requestBody = [];
    this.bookingWithinCancelCutOff.forEach((bookingId) => {
      const body = {
        modifierGuid: this.authService.user.employeeGuid,
        modifierBuid: this.authService.user.buId,
        bookingId,
        reason,
      };
      requestBody.push(body);
    });
    this.commonBookingService.cancelBooking(requestBody).subscribe((response) => {
      if (this.showCancelBookingSuccessCallback) {
        this.showCancelBookingSuccessCallback.emit();
      }
      this.showCancelConfirmDialog = false;
    }, (error) => {
      if (this.showCancelBookingErrorCallback) {
        this.showCancelBookingErrorCallback.emit(error);
      }
    });
  }

  handleCancelBooking(reason: string) {
    if (this.bookingWithinCancelCutOff.length) {
      if (this.toggleLoadingCallBack) {
        this.toggleLoadingCallBack.emit(true);
      }
      this.cancelBooking(reason);
    }
  }

  toggleCancelConfirmDialog(data: any) {
    this.selectedBookingDetailed.forEach((bookingDetails) => {
      if (this.commonBookingService.isBookingCancelDisabled(bookingDetails, this.cancelCutOffDetails)) {
        this.bookingWithinCancelCutOff.push(bookingDetails.bookingId);
      } else {
        this.bookingWithCutOffPassed.push(bookingDetails.bookingId);
      }
    });
    this.showCancelConfirmDialog = true;
  }

  dismissCancelBookingDialog() {
    this.showCancelConfirmDialog = false;
    this.bookingWithinCancelCutOff = [];
    this.bookingWithCutOffPassed = [];
  }

  handleDownloadBookingReport() {
    const searchQuery = {
      startDate: this.startDate.format('DD-MM-YYYY'),
      endDate: this.endDate.format('DD-MM-YYYY')
    };
    const bookingType = this.filterFormDetails ? this.filterFormDetails.get('bookingType').value : ['All'];
    const city = this.filterFormDetails ? this.filterFormDetails.get('city').value : ['All'];
    const office = this.filterFormDetails && this.filterFormDetails.get('office').value
     ? this.filterFormDetails.get('office').value : null;
    const vendorCabStatus = this.filterFormDetails ? this.filterFormDetails.get('vendorCabStatus').value : ['All'];
    const postBody = {
      bookingType,
      city,
      office,
      status: vendorCabStatus,
      buId: this.authService.user.buId,
      clientId: this.authService.client.client,
      employeeGUID: this.authService.user.employeeGuid
    };

    this.toggleLoadingCallBack.emit(true);
    this.bookingActionsHeaderService.downloadBookingDetails(searchQuery, postBody).subscribe((response: any) => {
      this.toggleLoadingCallBack.emit(false);
      this.commonBillingService.downloadBlob(response);
    }, (response) => {
      this.toggleLoadingCallBack.emit(false);
      this.downloadReportFailed = "Report download failed";
    });
  }

  handleDownlodSignInReport() {
    const searchQuery = {
      startDate: this.startDate.format('DD-MM-YYYY'),
      endDate: this.endDate.format('DD-MM-YYYY'),
      buid: this.authService.user.buId,
      client: this.authService.client.client,
    };
    const bookingType = this.filterFormDetails ? this.filterFormDetails.get('bookingType').value : ['All'];
    const city = this.filterFormDetails ? this.filterFormDetails.get('city').value : ['All'];
    const office = this.filterFormDetails && this.filterFormDetails.get('office').value
     ? this.filterFormDetails.get('office').value : null;
    const vendorCabStatus = this.filterFormDetails ? this.filterFormDetails.get('vendorCabStatus').value : ['All'];
    const postBody = {
      bookingType,
      city,
      office,
      status: vendorCabStatus,
      buId: this.authService.user.buId,
      clientId: this.authService.client.client,
      employeeGUID: this.authService.user.employeeGuid
    };
    this.toggleLoadingCallBack.emit(true);
    this.bookingActionsHeaderService.downloadSignInReport(searchQuery, postBody).subscribe((response: any) => {
      this.downloadAsCsvService.downloadcsvFile(response);
      this.toggleLoadingCallBack.emit(false);
    }, (response) => {
      this.toggleLoadingCallBack.emit(false);
      this.downloadReportFailed = "SignInReport download failed";
    });
  }

  hideDownloadReportError() {
    this.downloadReportFailed = '';
  }

  // toggleSendComm() {
  //   this.isSendCommVisible = !this.isSendCommVisible;
  //   if (this.toggleAutoReload) {
  //     const pauseAutoReload = this.isSendCommVisible ? true : false;
  //     this.toggleAutoReload.emit(pauseAutoReload);
  //   }
  // }

  toggleCabTrack() {
    this.isCabTrackVisible = !this.isCabTrackVisible;
    if (this.toggleAutoReload) {
      const pauseAutoReload = this.isCabTrackVisible ? true : false;
      this.toggleAutoReload.emit(pauseAutoReload);
    }
  }

  showBookingMerge() {
    if (this.selectedBookingDetailed.length < 2) {
      this.mergeError = "At least 2 bookings required for merge";
      return;
    }

    const maxBookings = this.commonService.getConfigForElementKey(this.mergeBookingConfig, 'Number of Bookings').config.defaultValue;
    if (maxBookings && this.selectedBookingDetailed.length > Number(maxBookings)) {
      this.mergeError = `Maximum of only ${maxBookings} can be merged at a time`;
      return;
    }

    let noOfOutstation = 0; const destinationCityMap = {}; const currTime = this.utilService.getMoment();
    const cityMap = {}; let noOfCancelledBooking = 0; let noOfUnapprovedBooking = 0; let vendorAllocated = false; const bookingTime = null;
    for (const booking of this.selectedBookingDetailed) {
      cityMap[booking.city] = true;
      if (booking.spotBookingType === 'Outstation') {
        noOfOutstation++;
        destinationCityMap[booking.destinationCity] = true;
      }
      if (booking.bookingStatus === 'CANCELLED') {
        noOfCancelledBooking++;
      }
      if (booking.managerStatus === 'PENDING') {
        noOfUnapprovedBooking++;
      }
      if (booking.vendor) {
        vendorAllocated = true;
      }
      if (this.utilService.getMoment(booking.startTime).isBefore(currTime)) {
        this.mergeError = `Only future bookings can be merged`;
        return;
      }
      if ( this.checkPreAssignedMarshall(booking)){
        this.mergeError = `
        Some of the booking(s) have marshall assigned to them.
        Please unassign the marshall, to proceed with merge booking. `;
        return;
      }
    }

    if (Object.keys(cityMap).length > 1) {
      this.mergeError = `Bookings from different cities cannot be merged`;
      return;
    }

    if (noOfOutstation && noOfOutstation !== this.selectedBookingDetailed.length) {
      this.mergeError = `Outstation bookings cannot be merged with other booking types`;
      return;
    }

    if (noOfOutstation && Object.keys(destinationCityMap).length > 1) {
      this.mergeError = `All booking must have the same destination`;
      return;
    }

    if (noOfCancelledBooking) {
      this.mergeError = `Cancelled bookings cannot be merged`;
      return;
    }

    if (noOfUnapprovedBooking) {
      this.mergeError = `Bookings for merge must be approved`;
      return;
    }
    if (vendorAllocated){
      this.mergeVendorError = true;
      return;
    }

    this.isMergeVisible = true;
    if (this.toggleAutoReload) {
      this.toggleAutoReload.emit(true);
    }

  }

  checkPreAssignedMarshall(booking) {
    return booking.stops.some(stop =>
      stop.riders.some(rider =>
        rider.riderType === 'MARSHAL' || rider.riderType === 'MARSHALL'
      )
    );
  }

  hideMergeBooking() {
    this.isMergeVisible = false;
    if (this.toggleAutoReload) {
      this.toggleAutoReload.emit(false);
    }
  }

  handleMergeSuccess(bookingData: any) {
    if (this.mergeBookingCallback) {
      this.mergeBookingCallback.emit(bookingData);
    }
    this.hideMergeBooking();
  }

  hideMergeBookingError() {
    this.mergeError = '';
  }

  handleSuccessToastToggle(message: string) {
    if (this.showSuccessToast) {
      this.showSuccessToast.emit(message);
    }
  }
  handleAllBookingsSelected(e) {
    this.checkboxSelected.emit(e);
  }

  selectVendorAssignedBookings() {
    this.selectVendorAssigned.emit();
  }

  selectVendorUnAssignedBookings() {
    this.selectVendorUnAssigned.emit();
  }
}
